import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../services/api';
import '../styles/auth.css';

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        
        try {
            // Step 1: Create user in Firebase
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            
            // Step 2: Get Firebase token
            const token = await user.getIdToken();
            
            // Step 3: Register user in our database with retry logic
            const userData = {
                username: email.split('@')[0], // Use email prefix as initial username
                display_name: email.split('@')[0] // Use email prefix as initial display name
            };
            
            try {
                await registerUser(userData, token);
                
                navigate('/explore');
            } catch (dbError) {
                console.error('❌ Database registration failed:', dbError);
                throw dbError; // Re-throw to trigger the Firebase rollback
            }
        } catch (err) {
            console.error('❌ Registration error:', err);
            
            // Provide user-friendly error messages
            if (err.message?.includes('email-already-in-use')) {
                setError('This email is already registered. Please try logging in instead.');
            } else if (err.message?.includes('weak-password')) {
                setError('Password should be at least 6 characters long.');
            } else if (err.message?.includes('invalid-email')) {
                setError('Please enter a valid email address.');
            } else {
                setError(err.message || 'Registration failed. Please try again.');
            }
        }
    };

    return (
        <div className="auth-container">
            <h2 className="auth-title">Register</h2>
            <form onSubmit={handleRegister} className="auth-form">
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button type="submit" className="auth-button">Register</button>
            </form>
            {error && <p className="error-message compact">{error}</p>}
            <div className="auth-link">
                Already have an account? <a href="/login">Login here</a>
            </div>
        </div>
    );
};

export default Register;